import script from "./TopNav.vue?vue&type=script&lang=ts&setup=true"
export * from "./TopNav.vue?vue&type=script&lang=ts&setup=true"

import "./TopNav.vue?vue&type=style&index=0&id=4ec2d1d7&scoped=true&lang=css"
/* custom blocks */
import block0 from "./TopNav.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ec2d1d7"]])

export default __exports__